import React from 'react';
import { PeopleIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { convertToBillingUrl } from '../../../nav/utils/getBillingBaseUrl';

const chipStatus = {
  Completed: 'success',
  Draft: 'default',
  Pending: 'primary',
};

function renderItem(order, t): Nullable<SearchItemViewModel> {
  return {
    title: order['OrderNumber'],
    descriptionFields: [
      {
        type: 'Text',
        value: order['Account.Name'],
        title: order['Account.Name'],
      },
      {
        type: 'Text',
        value: order['Account.AccountNumber'],
        title: order['Account.AccountNumber'],
      },
      { type: 'Date', value: order['OrderDate'], title: t('Order.OrderDate') },
    ],
    chipField: {
      state: chipStatus[order['Status']],
      label: t(`Order.Status.${order['Status']}`),
    },
    href: convertToBillingUrl(`/orders#/view/${order['OrderNumber']}`),
  };
}

export const Order: SearchMeta = {
  objectType: 'Order',
  objectLabelI18n: 'Order.TabLabel',
  needsPermission: true,
  tabIcon: <PeopleIcon />,
  listPageUrl: convertToBillingUrl('/apps/Order.do'),
  hasAdvancedSearch: true,
  renderItem,
};
